import { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface FloatingPanelProps {
  children: ReactNode
  className?: string
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl"
}

export function FloatingPanel({ 
  children, 
  className,
  maxWidth = "3xl" 
}: FloatingPanelProps) {
  const maxWidthClass = {
    sm: "max-w-screen-sm",
    md: "max-w-screen-md",
    lg: "max-w-screen-lg",
    xl: "max-w-screen-xl",
    "2xl": "max-w-screen-2xl",
    "3xl": "max-w-3xl", // Using specific value from original code
  }[maxWidth]

  return (
    <div className={cn(
      "w-full mx-auto rounded-xl bg-card-surface/50 shadow-xl shadow-black/5 dark:shadow-none border border-white/50 dark:border-white/5 overflow-hidden",
      maxWidthClass,
      className
    )}>
      {children}
    </div>
  )
}
